import * as React from 'react';
import { CheckboxButtonFilter } from '../../../../components/Filters';
import { useEventCallback } from '@cian/react-utils';
import { useDispatch, useSelector } from 'react-redux';
import { applyFilters, setSavedFilters } from '../../../../actions/filters';
import { selectOpenVillageFilter } from '../../../../selectors/filters';
import { useOpenVillageFilterAvailable } from '../../../../hooks';

export const OpenVillageContainer = () => {
  const dispatch = useDispatch();
  const filterAvailable = useOpenVillageFilterAvailable();
  const checked = useSelector(selectOpenVillageFilter);

  const handleChange = useEventCallback((checked: boolean) => {
    dispatch(setSavedFilters({ withOpenVillage: checked || undefined }));
    dispatch(applyFilters());
  });

  if (!filterAvailable) {
    return null;
  }

  return (
    <CheckboxButtonFilter
      label="Участник Open Village"
      checked={checked}
      onChange={handleChange}
      dataName="OpenVillage"
    />
  );
};
